module.exports = __webpack_public_path__ + "media/images/icons/facilities/no-wifi-66c34887388ae6a4db38ff2f8e777a8b.svg";